import React, { useRef } from "react";
import { DatePicker, message } from "antd";
import { Dayjs } from "dayjs";

const MobileDateRange = ({
  filterDates,
  setFilterDates,
}: {
  filterDates: any;
  setFilterDates: any;
}) => {
  const endPickerRef = useRef<any>(null);

  const handleStartChange = (start: Dayjs | null) => {
    if (!start) return;
    const end = filterDates[1];
    if (end && end.isBefore(start)) {
      message.error("Start date cannot be after end date");
      return;
    }

    setFilterDates([start.startOf("day"), end]);

    // Auto-focus end date picker
    setTimeout(() => {
      endPickerRef.current?.focus?.();
    }, 100);
  };

  const handleEndChange = (end: Dayjs | null) => {
    const start = filterDates[0];
    if (!end) return;
    if (start && end.isBefore(start)) {
      message.error("End date cannot be before start date");
      return;
    }
    setFilterDates([start, end.endOf("day")]);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <DatePicker
        placeholder="Start Date"
        value={filterDates[0]}
        onChange={handleStartChange}
      />
      <DatePicker
        ref={endPickerRef}
        placeholder="End Date"
        value={filterDates[1]}
        onChange={handleEndChange}
      />
    </div>
  );
};

export default MobileDateRange;
